var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-button",class:[_vm.type, _vm.size, _vm.disabled ? 'disabled' : '', _vm.icon ? 'with-icon' : ''],on:{"click":_vm.$_onBtnClick}},[_c('div',{staticClass:"md-button-inner"},[(_vm.icon)?[_c('md-icon',{attrs:{"name":_vm.icon}})]:_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04b3a6c9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/vxmobile/components/button/index.vue
// module id = null
// module chunks = 